import { StatusBadge } from 'features/inbox/components/shared/styledElements'
import {
  INSPECTION_STATUS_LABELS,
  InspectionStatus,
} from 'features/inbox/types/types'
import React, { memo } from 'react'

interface StatusBadgeComponentProps {
  status: InspectionStatus
}

const StatusBadgeComponentBase: React.FC<StatusBadgeComponentProps> = ({
  status,
}) => {
  return (
    <StatusBadge $status={status}>
      {INSPECTION_STATUS_LABELS[status]}
    </StatusBadge>
  )
}

export const StatusBadgeComponent = memo(StatusBadgeComponentBase)
